// extracted by mini-css-extract-plugin
export default {"fixedWidthBtn":"styles_fixedWidthBtn__LaYnA","fixedButton":"styles_fixedButton__i1U-l"};